import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';

import { JoyrideDirective } from './directives/joyride.directive';

import {
  JoyrideButtonComponent,
  JoyrideArrowComponent,
  JoyrideStepComponent,
  JoyrideBackButtonComponent,
  JoyrideCloseButtonComponent
} from './components';

@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
    TranslateModule.forChild()
  ],
  declarations: [
    JoyrideDirective,
    JoyrideStepComponent,
    JoyrideArrowComponent,
    JoyrideButtonComponent,
    JoyrideCloseButtonComponent,
    JoyrideBackButtonComponent
  ],
  exports: [
    JoyrideDirective
  ]
})
export class JoyrideModule {
}
